export default "__VITE_ASSET__xbO2K1gI__"